module.exports = __webpack_public_path__ + "static/media/CE.de740205.png";